import { IconButton } from '@mui/material';
import { Search } from '@mui/icons-material';
import camelcaseKeys from 'camelcase-keys';
import { UseFormGetValues, UseFormReset } from 'react-hook-form';

import { getPatient } from '../PatientList/api';
import useNotification from 'hooks/useNotification';
import useUser from 'store/user/useUser';

interface Props {
  reset: UseFormReset<any>;
  getValues: UseFormGetValues<any>;
  setIsSearched: (value: boolean) => void;
  onPatientLoaded?: () => void;
}

const SearchPatientId = ({
  reset,
  getValues,
  setIsSearched,
  onPatientLoaded,
}: Props) => {
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { student_college } = useUser();

  const onSearch = () => {
    const patientId = getValues('patient.patientId');
    if (!patientId) return onRequired('REQUIRED.PATIENT.ID');
    const collegeId = student_college || getValues('patient.college');
    if (!collegeId) return onRequired('CREATE.SCHOOL');

    getPatient({ patientId, collegeId })
      .then(({ data: { rc, ...values } }) => {
        if (rc !== 1) return onResultCode(rc);

        let defaultValue = {} as any;
        for (const key in values) {
          defaultValue[key] = camelcaseKeys(values[key]);
        }

        reset(defaultValue);
        onPatientLoaded?.();
        onSuccess('가상환자 조회에 성공하였습니다.');
        setIsSearched(true);
      })
      .catch(e => onFail('가상환자 조회에 실패하였습니다', e));
  };

  return (
    <IconButton size="small" onClick={onSearch}>
      <Search sx={{ fontSize: 16 }} />
    </IconButton>
  );
};

export default SearchPatientId;
